import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}


// 驻站专家-列表

export async function replyPostAns(params) {
  try {
    return await API.post("/api/" + prout + "/api/post_ans/add", params);
  } catch (error) {
    return error;
  }
}
export async function likePostAns(params) {
  try {
    return await API.post("/api/" + prout + "/api/post_ans/like", params);
  } catch (error) {
    return error;
  }
}
export async function essencePostAns(params) {
  try {
    return await API.post("/api/" + prout + "/api/post_ans/setEssence", params);
  } catch (error) {
    return error;
  }
}
export async function deletePostAns(params) {
  try {
    return await API.post("/api/" + prout + "/api/post_ans/delete", params);
  } catch (error) {
    return error;
  }
}

export function ansList(params) {
  return API.post("/api/" + prout + "/api/post_ans/ansList", params);
}

export async function home(params) {
  return await API.get("/api/" + prout + "/api/post/home", params);
}

export async function list(params) {
  return await API.get("/api/" + prout + "/api/post/list", {
    params
  });
}
export function getAreaTree() {
  return API.get("/api/" + prout + "/api/post/getAreaTree");
}

export function info(params) {
  return API.post("/api/" + prout + "/api/post/info", params);
}

export function share(params) {
  return API.post("/api/" + prout + "/api/post/share", params);
}

export function toggleLike(params) {
  return API.post("/api/" + prout + "/api/post/toggleLike", params);
}

export function toggleCollection(params) {
  return API.post("/api/" + prout + "/api/post/toggleCollection", params);
}

export function related(params) {
  return API.post("/api/" + prout + "/api/post/related", params);
}

export async function downAnnex(params) {
  return API.get("/api/" + prout + "/api/post/downAnnex", params, {
  });
}

export async function moderatorList(params) {
  try {
    return await API.post("/api/" + prout + "/api/moderator/index", params);
  } catch (error) {
    return error;
  }
}
export async function topUp(params) {
  try {
    return await API.post("/api/" + prout + "/api/moderator/topUp", params);
  } catch (error) {
    return error;
  }
}
export async function setEssence(params) {
  try {
    return await API.post("/api/" + prout + "/api/moderator/setEssence", params);
  } catch (error) {
    return error;
  }
}
export async function moderatorDelete(params) {
  try {
    return await API.post("/api/" + prout + "/api/moderator/delete", params);
  } catch (error) {
    return error;
  }
}

export async function audit(params) {
  try {
    return await API.post("/api/" + prout + "/api/moderator/audit", params);
  } catch (error) {
    return error;
  }
}
